export default "__VITE_ASSET__Fi2EWpzs__"